export const formatPrice = (cents) => {
  if (cents == null) return "";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
};

export const cn = (...classes) => classes.filter(Boolean).join(" ");

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

/** Convert stored image URL (e.g. "/api/media/foo/standard.webp") to an absolute URL. */
export const imgUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND}${path}`;
};
